const ShippingLanesSetType = {
	SHIPPING: "shipping",
	FISHING: "fishing",
	TRAWLING: "trawling",
	DARK: "dark"
};
export default ShippingLanesSetType;
